/**
 * React Starter Kit (https://www.reactstarterkit.com/)
 *
 * Copyright © 2014-present Kriasoft, LLC. All rights reserved.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.txt file in the root directory of this source tree.
 */

import React from 'react';
import PropTypes from 'prop-types';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import s from './Platform.css';
import Ranktable from './../../components/Ranktable'
import Article from './../../components/Article'
import Hotpush from './../../components/Hotpush'
import moment from 'moment'

const list=[
  '微信',
  '微博',
  '今日头条',
  '知乎'
]

class Platform extends React.Component {
  
  constructor(){
    super()
    this.state={
      listIndex:0,
      time:null
    }
    this.getArtTime=this.getArtTime.bind(this)
  }

  componentWillMount() {
    if(moment().format('a')=='pm'){
      this.setState({time:`${moment().subtract(7,'days').format('YYYY-MM-DD')},${moment().subtract(1,'days').format('YYYY-MM-DD')}`})
    }else{
      this.setState({time:`${moment().subtract(8,'days').format('YYYY-MM-DD')},${moment().subtract(2,'days').format('YYYY-MM-DD')}`})
    }
  }

  getArtTime=(ss)=>{
    this.setState({time:ss})
  }

  render() {

    const {listIndex}=this.state
    return (
      <div className={s.root}>
        {/* <div className={s.platform}>
					<p className={s.blod}>
						平台：
					</p>
          {list.map((item,index)=>
            <span key={index} className={listIndex==index?s.platformAc:null} onClick={()=>{this.setState({listIndex:index})}}>{item}</span>
          )}
				
				</div> */}
        <Ranktable rank='platform' tit={this.props.childrenData} getArtTime={this.getArtTime}/>
        {/* <Article time={this.state.time} platform={list[listIndex]}/> */}
      </div>
    );
  }
}

export default withStyles(s)(Platform);



// WEBPACK FOOTER //
// src/routes/platform/Platform.js